import * as React from "react";
const SvgFiRrFlowerTulip = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-flower-tulip_svg__a)">
      <path
        fill="#062147"
        d="M23.535 14.725a1.99 1.99 0 0 0-1.726-.716A12 12 0 0 0 13 18.987V13.91A6.006 6.006 0 0 0 18 8c0-2.793-1.943-5.152-3.844-7.091a3.085 3.085 0 0 0-4.312 0C7.944 2.848 6 5.207 6 7.999a6.006 6.006 0 0 0 5 5.91v5.078a12 12 0 0 0-8.809-4.978 1.99 1.99 0 0 0-1.726.716 1.97 1.97 0 0 0-.393 1.792C2.112 23.855 11.592 24 11.994 24h.012c.4 0 9.884-.145 11.923-7.483a1.97 1.97 0 0 0-.394-1.792M8 8c0-2.654 3.318-5.72 3.338-5.736C10.973 3.2 8.693 8.9 11 9a1 1 0 0 0 1-1 13.5 13.5 0 0 1 1.257-5.137C14.688 4.393 16 6.153 16 8a4 4 0 1 1-8 0m-5.994 8a10.27 10.27 0 0 1 8.462 5.863C7.971 21.517 3.2 20.3 2.006 16m11.54 5.86A10.38 10.38 0 0 1 22 15.98c-1.194 4.303-5.954 5.53-8.455 5.88"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-flower-tulip_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlowerTulip;
